import { memo } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { colors } from "@/utils/const";

const OUTRO_TEXT_SX = {
  fontSize: { xs: "16px", lg: "24px" },
  color: "#040921",
  py: 2,
  lineHeight: 1.6,
};

const SUB_OUTRO_TEXT_SX = {
  color: colors.orange,
  fontWeight: 600,
  fontSize: { xs: "18px", md: "24px" },
  pt: 2,
  lineHeight: 1.4,
  minHeight: { xs: "26px", md: "32px" },
};

function Outro({ outro, bgColor = "#f8f8f8", flag = false, subOutro }) {
  const showSubOutro = flag && Boolean(subOutro);

  return (
    <Box
      component="section"
      className="horizontal-safe-padding vertical-safe-padding"
      sx={{
        bgcolor: bgColor,
        textAlign: "center",
      }}
    >
      <Typography component="p" sx={OUTRO_TEXT_SX}>
        {outro}
      </Typography>

      {showSubOutro && (
        <Typography component="p" sx={SUB_OUTRO_TEXT_SX}>
          {subOutro}
        </Typography>
      )}
    </Box>
  );
}

export default memo(Outro);